module.exports = __webpack_public_path__ + "img/istockphoto-992723194-612x612.a9ee732c.jpg";